// import React, { useState, useEffect } from 'react';

// const Timer = ({ text, countdown }) => {
//     console.log(countdown);
//     const [timeLeft, setTimeLeft] = useState(countdown);

//     useEffect(() => {
//         const timer = setInterval(() => {
            
//             setTimeLeft(prevTime => prevTime - 1);
//         }, 1000);

//         return () => clearInterval(timer);
//     }, []);

//     const formatTime = time => {
//         const minutes = Math.floor(time / 60);
//         const seconds = time % 60;
//         return `${seconds < 10 ? seconds : seconds}`;
//     };

//     return (
//         <div>
//             <p>{text} {formatTime(timeLeft)}</p>
//         </div>
//     );
// };

// export default Timer;






import React, { useState, useEffect } from 'react';

const Timer = ({ text, countdown, onTimerUpdate ,sec}) => {
  const [timeLeft, setTimeLeft] = useState(countdown);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        const newTime = prevTime - 1;
        if (newTime <= 0) {
          onTimerUpdate(newTime);
          clearInterval(timer);
          return 0;
        }
        onTimerUpdate(newTime); 
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onTimerUpdate]);

  const formatTime = time => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${seconds < 10 ? seconds : seconds}`;
  };

  return (
    <div>
      <p style={{color:'red'}}>{text} {formatTime(timeLeft)} {sec}</p>
    </div>
  );
};

export default Timer;
